// extracted by mini-css-extract-plugin
export default {"unit":"styles_unit__ba2mv","headerContainer":"styles_headerContainer__s7gzr","header":"styles_header__wc76w","text":"styles_text__JYmnh","icon":"styles_icon__4z5nP"};